import { render } from "./UserCategoryDetailsView.vue?vue&type=template&id=19e12614&scoped=true"
import script from "./UserCategoryDetailsView.vue?vue&type=script&lang=js"
export * from "./UserCategoryDetailsView.vue?vue&type=script&lang=js"

import "./UserCategoryDetailsView.vue?vue&type=style&index=0&id=19e12614&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19e12614"],['__file',"src/views/UserCategoryDetailsView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "19e12614"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('19e12614', __exports__)) {
    api.reload('19e12614', __exports__)
  }
  
  module.hot.accept("./UserCategoryDetailsView.vue?vue&type=template&id=19e12614&scoped=true", () => {
    api.rerender('19e12614', render)
  })

}


export default __exports__